import { useContext } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";

export default function KarayoluAgacDegerleme() {
  const {
    agaclar,
    agacListesi,
    setAgacListesi,
    meyveVar,
    setMeyveVar,

    //Bir Çılgınlık yapıp tomruk bedelini de hesaplattım

    ormanAgaclari,
    ormanAgacListesi,
    setOrmanAgacListesi,
    ormanAgaciVar,
    setOrmanAgaciVar,
  } = useContext(GlobalContext);

  //GLOBALE YOLLA

  //Orman Ağaçları
  const ormanAgacDegeriDegistir = (e, index) => {
    const { name, value } = e.target;
    const list = [...ormanAgacListesi];
    list[index][name] = value;
    setOrmanAgacListesi(list);

    console.log(list);
  };

  const ormanAgacSil = (index) => {
    const list = [...ormanAgacListesi];
    list.splice(index, 1);
    setOrmanAgacListesi(list);
  };

  const ormanAgacEkle = () => {
    setOrmanAgacListesi([
      ...ormanAgacListesi,
      {
        ormanAgacAdi: "",
        cap: "",
        yukseklik: "",
        ormanAgaciAdet: "",
        m3Fiyati: "",
      },
    ]);
  };

  const ormanAgaciVarMi = () => {
    setOrmanAgaciVar(true);
    setOrmanAgacListesi([{}]);
  };

  const ormanAgaciYokMu = () => {
    setOrmanAgaciVar(false);
    setOrmanAgacListesi([]);
  };

  //Orman Ağaçları

  //Meyve Ağaçları

  const agacDegeriDegistir = (e, index) => {
    const { name, value } = e.target;
    const list = [...agacListesi];
    list[index][name] = value;
    setAgacListesi(list);
    console.log(list);
  };

  const agacSil = (index) => {
    const list = [...agacListesi];
    list.splice(index, 1);
    setAgacListesi(list);
  };

  const agacEkle = () => {
    setAgacListesi([
      ...agacListesi,
      { agacAdi: "", agacYasi: "", agacAdet: "", adetFiyati: "" },
    ]);
  };
  //Meyve Ağaçları

  const meyveAgaciVar = () => {
    setMeyveVar(true);
    setAgacListesi([{}]);
  };

  const meyveAgaciYok = () => {
    setMeyveVar(false);
    setAgacListesi([]);
  };

  const AgacToplamFiyatHesapla = () => {};

  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center my-3">
            Taşınmaz Üzerindeki Ağaçların Değerlemesi{" "}
          </h1>
        </div>

        {/* MEYVE AĞAÇLARI KISMI */}
        <div className="col-6">
          <div className="form-check">
            <input
              className="form-check-input "
              type="radio"
              name="meyveAgaciDurumu"
              id="meyveYok"
              checked={meyveVar === false ? true : false}
              onChange={() => meyveAgaciYok()}
            />
            <label className="form-check-label text-danger" htmlFor="meyveYok">
              Taşınmaz Üzerinde Meyve Ağacı <b>Yoktur.</b>
            </label>
          </div>
          <div className="form-check mb-5">
            <input
              className="form-check-input"
              type="radio"
              name="meyveAgaciDurumu"
              id="meyveVar"
              checked={meyveVar === true ? true : false}
              onChange={() => meyveAgaciVar()}
            />
            <label className="form-check-label" htmlFor="meyveVar">
              Taşınmaz Üzerinde Meyve Ağacı <b>Vardır.</b>
            </label>
          </div>
        </div>
        {meyveVar ? (
          <div className="row">
            <div className="row my-3">
              <h3 className="text-primary">
                Taşınmaz Üzerinde Bulunan <b>Meyve</b> Ağaçlarının Özelliklerini
                Giriniz
              </h3>
            </div>

            <div className="col mt-1 my-5 mx-2">
              {agacListesi.map((evrak, index) => (
                <div key={index} className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-center text-success">
                      Ağaç #{index + 1}
                    </h5>
                    <div className="row">
                      <div className="col-md-3">
                        <label
                          htmlFor={`agacAdi-${index}`}
                          className="form-label"
                        >
                          Ağaç Adı
                        </label>
                        <select
                          id={`agacAdi-${index}`}
                          name="agacAdi"
                          onChange={(e) => agacDegeriDegistir(e, index)}
                          className="form-select"
                          value={agacListesi[index].agacAdi || ""}
                        >
                          <option value="">--Ağaç Adı Seçiniz--</option>
                          {agaclar.map((agac, i) => (
                            <option key={i} value={agac.agacAdi}>
                              {agac.agacAdi}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor={`agacYasi-${index}`}
                          className="form-label"
                        >
                          Yaşı
                        </label>
                        <input
                          id={`agacYasi-${index}`}
                          name="agacYasi"
                          type="number"
                          className="form-control"
                          placeholder="Yaş"
                          value={agacListesi[index].agacYasi || ""}
                          onChange={(e) => agacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor={`agacAdet-${index}`}
                          className="form-label"
                        >
                          Adet
                        </label>
                        <input
                          id={`agacAdet-${index}`}
                          name="agacAdet"
                          type="number"
                          className="form-control"
                          placeholder="Adet"
                          value={agacListesi[index].agacAdet || ""}
                          onChange={(e) => agacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor={`adetFiyati-${index}`}
                          className="form-label"
                        >
                          Adet Fiyatı (₺)
                        </label>
                        <input
                          id={`adetFiyati-${index}`}
                          name="adetFiyati"
                          type="number"
                          className="form-control"
                          placeholder="₺"
                          value={agacListesi[index].adetFiyati || ""}
                          onChange={(e) => agacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-2 d-flex align-items-end">
                        {agacListesi.length !== 1 && (
                          <button
                            type="button"
                            onClick={() => agacSil(index)}
                            className="btn btn-danger w-100"
                          >
                            Sil
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {agacListesi.length < 20 && (
                <button onClick={agacEkle} className="btn btn-primary mt-3">
                  Ağaç Ekle
                </button>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        {/* ORMAN AĞAÇLARI KISMI */}
        <div className="col-6">
          <div className="form-check mt-5">
            <input
              className="form-check-input "
              type="radio"
              name="ormanAgaciDurumu"
              id="ormanYok"
              checked={ormanAgaciVar === false ? true : false}
              onChange={() => ormanAgaciYokMu()}
            />
            <label className="form-check-label text-danger" htmlFor="ormanYok">
              Taşınmaz Üzerinde Orman Ağacı <b>Yoktur.</b>
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="ormanAgaciDurumu"
              id="ormanVar"
              checked={ormanAgaciVar === true ? true : false}
              onChange={() => ormanAgaciVarMi()}
            />
            <label className="form-check-label" htmlFor="ormanVar">
              Taşınmaz Üzerinde Orman Ağacı <b>Vardır.</b>
            </label>
          </div>
        </div>

        {ormanAgaciVar ? (
          <div className="row">
            <div className="row my-3">
              <h3 className="text-success">
                Taşınmaz Üzerinde Bulunan <b>Orman</b> Ağaçlarının Özelliklerini
                Giriniz
              </h3>
            </div>

            <div className="col mt-1 my-5 mx-2">
              {ormanAgacListesi.map((evrak, index) => (
                <div key={index} className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-center text-primary">
                      Orman Ağacı #{index + 1}
                    </h5>
                    <div className="row">
                      <div className="col-md-2">
                        <label
                          htmlFor={`ormanAgacAdi-${index}`}
                          className="form-label"
                        >
                          Ağaç Adı
                        </label>
                        <select
                          id={`ormanAgacAdi-${index}`}
                          name="ormanAgacAdi"
                          onChange={(e) => ormanAgacDegeriDegistir(e, index)}
                          className="form-select"
                          value={ormanAgacListesi[index].ormanAgacAdi || ""}
                        >
                          <option value="">--Orman Ağacı Adı Seçiniz--</option>
                          {ormanAgaclari.map((agac, i) => (
                            <option key={i} value={agac.agacAdi}>
                              {agac.agacAdi}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label htmlFor={`cap-${index}`} className="form-label">
                          Ağaç Çapı (Metre)
                        </label>
                        <input
                          id={`cap-${index}`}
                          name="cap"
                          type="number"
                          className="form-control"
                          placeholder="Ağaç Çapı"
                          value={ormanAgacListesi[index].cap || ""}
                          onChange={(e) => ormanAgacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor={`yukseklik-${index}`}
                          className="form-label"
                        >
                          Yükseklik (Metre)
                        </label>
                        <input
                          id={`yukseklik-${index}`}
                          name="yukseklik"
                          type="number"
                          className="form-control"
                          placeholder="Yukseklik"
                          value={ormanAgacListesi[index].yukseklik || ""}
                          onChange={(e) => ormanAgacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor={`ormanAgaciAdet-${index}`}
                          className="form-label"
                        >
                          Adet
                        </label>
                        <input
                          id={`ormanAgaciAdet-${index}`}
                          name="ormanAgaciAdet"
                          type="number"
                          className="form-control"
                          placeholder="Adet"
                          value={ormanAgacListesi[index].ormanAgaciAdet || ""}
                          onChange={(e) => ormanAgacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor={`m3Fiyati-${index}`}
                          className="form-label"
                        >
                          m3 Fiyatı (₺)
                        </label>
                        <input
                          id={`m3Fiyati-${index}`}
                          name="m3Fiyati"
                          type="number"
                          className="form-control"
                          placeholder="₺"
                          value={ormanAgacListesi[index].m3Fiyati || ""}
                          onChange={(e) => ormanAgacDegeriDegistir(e, index)}
                        />
                      </div>
                      <div className="col d-flex align-items-end">
                        {ormanAgacListesi.length !== 1 && (
                          <button
                            type="button"
                            onClick={() => ormanAgacSil(index)}
                            className="btn btn-danger w-100"
                          >
                            Sil
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {ormanAgacListesi.length < 20 && (
                <button
                  onClick={ormanAgacEkle}
                  className="btn btn-success mt-3"
                >
                  Orman Ağacı Ekle
                </button>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-3">
            <div className="row">
              <Link to="/kyobjektifunsurlar">
                <button className="btn btn-success btn-lg mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>
                  Objektif Unsurlar
                </button>
              </Link>
            </div>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <div className="row">
              {" "}
              <Link to="/kyresimekle">
                {" "}
                <button
                  onClick={AgacToplamFiyatHesapla()}
                  className="btn btn-primary btn-lg mt-5"
                >
                  Keşif Resimleri
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </GlobalProvider>
  );
}
